import {
  endOfQuarter,
  getMonth,
  getQuarter,
  getYear,
  isBefore,
  startOfQuarter,
  subQuarters,
} from 'date-fns'

// 四半期期間の型 (例: '2025q1', '2026q3')
export type QuarterPeriod =
  `${2}${0}${2 | 3 | 4 | 5 | 6 | 7 | 8 | 9}${0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9}q${1 | 2 | 3 | 4}`
// 全期間タイプのユニオン型
export type PeriodValue = 'last3months' | QuarterPeriod

export type PeriodOption = {
  label: string
  value: PeriodValue
}

type GeneratePeriodOptions = (input: {
  startDate?: Date
  endDate?: Date
}) => PeriodOption[]

/*/**
 * 四半期の開始月と終了月を取得する
 */
const getQuarterMonths = (date: Date) => {
  const quarterStart = startOfQuarter(date)
  const quarterEnd = endOfQuarter(date)
  const startMonth = getMonth(quarterStart) + 1 // getMonthは0ベースなので+1
  const endMonth = getMonth(quarterEnd) + 1
  return { startMonth, endMonth }
}

/**
 * 開始年月から終了日時まで四半期ごとに生成する
 * 例: startDate = 2025-01-01, endDate = 2025-12-31, output = 2025q1, 2025q2, 2025q3, 2025q4
 */
export const generatePeriodOptions: GeneratePeriodOptions = (
  // オプション機能をリリースした2025年1月〜3月期をデフォルトの基準にする
  { startDate = new Date('2025-01-01'), endDate = new Date() },
) => {
  const options: PeriodOption[] = [{ label: '直近3ヶ月', value: 'last3months' }]

  // 終了日の四半期開始日から開始
  let currentQuarterDate = startOfQuarter(endDate)
  const minQuarterStart = startOfQuarter(startDate)

  // 現在の四半期から過去に向かって生成
  while (!isBefore(currentQuarterDate, minQuarterStart)) {
    const year = getYear(currentQuarterDate)
    const quarter = getQuarter(currentQuarterDate)
    const { startMonth, endMonth } = getQuarterMonths(currentQuarterDate)

    const label = `${year}年${startMonth}月〜${endMonth}月`
    const value = `${year}q${quarter}` as PeriodValue

    options.push({ label, value })

    // 前の四半期に移動
    currentQuarterDate = subQuarters(currentQuarterDate, 1)
  }

  return options
}
